module.exports = __webpack_public_path__ + "img/navigation_browser_3.1fcb40a6.png";